import { withState } from 'recompose'
import BaseMapDisplay from './base-map-display'

export default withState(
  'selectedLocation',
  'setSelectedLocation',
  ({ selectedLocation }) => selectedLocation
)(BaseMapDisplay)
